export const openCenterPopup = (url: string, width = 500, height = 600, top = 200) => {
  const left = (window.screen.width - width) / 2;
  return window.open(url, "popup", `width=${width}, height=${height}, top=${top}, left=${left}`);
};

export const openTab = (path: string) => window.open(path, "_blank");
